<template>
    <b-container fluid class="home-container">
        <b-row align-h="center">
            <b-col lg="4" sm="6" md="5" cols="12" style="padding-right: 0 !important; margin-right: 0 !important; padding-left: 0 !important; margin-left: 0 !important;">
                <b-row class="mt-5" align-h="center">
                    <router-link to="/">
                        <img @click="select='login'" src="@/assets/images/logo.png" href="/" alt/>
                    </router-link>
                </b-row>
                <div v-if="select=='login'">
                    <b-row align-h="center">
                        <p class="welcome">
                            Bienvenido,
                            <br/>por favor escoja una cuenta
                        </p>
                    </b-row>
                    <b-row align-h="center">
                        <button @click="select='adviser'" type="button" class="mt-2 home-button">SOY ASESOR</button>
                        <button @click="select='school'" type="button" class="mt-3 home-button">SOY COLEGIO</button>
                        <button @click="select='student'" type="button" class="mt-3 home-button">SOY ESTUDIANTE</button>
                    </b-row>
                </div>
                <b-row v-if="select=='adviser'" class="content-login-form">
                    <b-form  @submit.stop.prevent="loginAsesor" class="content-form">
                        <b-form-group label-align="center" id="formAsesorEmail">
                            <b-form-input
                                    class="input-login"
                                    v-model="$v.formAsesor.email.$model"
                                    placeholder="asesor@ucsp.pe"
                                    aria-describedby="mensajeLiveFeedback"
                                    :state="asesorEmailState('email')"
                            ></b-form-input>
                            <b-form-invalid-feedback id="mensajeLiveFeedback">
                                Debe ingresar un correo valido
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="formColegioPassword" class="mt-5">
                            <img src="@/assets/images/Eye.svg" @click="showPassword()">
                            <b-form-input
                                    v-model="$v.formAsesor.password.$model"
                                    class="input-login"
                                    :type="typePassword"
                                    placeholder="contraseña"
                                    aria-describedby="mensajeLiveFeedback"
                                    :state="asesorPasswordState('password')"

                            ></b-form-input>
                            <b-form-invalid-feedback id="mensajeLiveFeedback">
                                Debe ingresar el password
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-row class="mr-4">
                            <b-col style="text-align: right">
                                <span class="text-olvido">olvide mi contraseña</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-lg-5">
                            <b-col style="text-align: center">
                                <button class="home-button-login" id="enviar-support" type="submit"
                                        :disabled="$v.formAsesor.$invalid">
                                    <span>INGRESAR</span>
                                </button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-row>
                <b-row v-if="select=='school'" class="content-login-form">
                    <b-form @submit.stop.prevent="loginColegio" class="content-form">
                        <b-form-group label-align="center" id="formColegioEmail">
                            <b-form-input
                                    class="input-login"
                                    v-model="$v.formColegio.email.$model"
                                    placeholder="colegio@ucsp.pe"
                                    aria-describedby="mensajeLiveFeedback"
                                    :state="colegioEmailState('email')"
                            ></b-form-input>
                            <b-form-invalid-feedback id="mensajeLiveFeedback">
                                Debe ingresar un correo valido
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="formColegioPassword" class="mt-5">
                            <img src="@/assets/images/Eye.svg" @click="showPassword()">
                            <b-form-input
                                    v-model="$v.formColegio.password.$model"
                                    class="input-login"
                                    :type="typePassword"
                                    placeholder="contraseña"
                                    aria-describedby="mensajeLiveFeedback"
                                    :state="colegioPasswordState('password')"

                            ></b-form-input>
                            <b-form-invalid-feedback id="mensajeLiveFeedback">
                                Debe ingresar el password
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-row class="mr-4">
                            <b-col style="text-align: right">
                                <span class="text-olvido">olvide mi contraseña</span>
                            </b-col>
                        </b-row>
                        <b-row class="mt-lg-5">
                            <b-col style="text-align: center">
                                <button class="home-button-login" id="enviar-support" type="submit"
                                        :disabled="$v.formColegio.$invalid">
                                    <span>INGRESAR</span>
                                </button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-row>
                <b-form v-if="select=='student'" @submit.stop.prevent="enviarKey">
                    <b-row class="mt-5" align-h="center">
                        <b-card class="text-center" align="center">
                            <b-tabs content-class="content-tab-home" active-nav-item-class="tab1" card>
                                <b-tab
                                        title-link-class="tab-link"
                                        title-item-class="tabs-home"
                                        title="SIMULACRO"
                                        active
                                >
                                    <b-card-text class="welcome2 text-center">
                                        Bienvenido, por favor ingresa el Key proporcionado por el
                                        Coordinador de tu Colegio.
                                    </b-card-text>
                                    <b-form  @submit.stop.prevent="enviarKey" class="content-form-2 mt-5">
                                        <b-form-group label-align="center" id="formColegioEmail">
                                            <b-form-input
                                                    class="input-login-estudiante"
                                                    v-model="$v.formEstudiante.keys.$model"
                                                    placeholder="Key"
                                                    aria-describedby="keysLiveFeedback"
                                                    :state="estudianteKeysState('keys')"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="keysLiveFeedback">
                                                Debe ingresar un key
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group label-align="center" id="formColegioEmail">
                                            <b-form-input
                                            placeholder="Correo"
                                            id="correo"
                                            :state="validateState('correo')"
                                            class="input-login-estudiante"
                                            type="email"
                                            ref="correo"
                                            v-model="$v.formEstudiante.correo.$model"
                                            />
                                            <b-form-invalid-feedback id="input-7-live-feedback"
                                            >Escribir un correo valido</b-form-invalid-feedback
                                            >
                                            
                                        </b-form-group>
 
                                        <b-row class="mt-lg-5">
                                            <b-col style="text-align: center">
                                                <button class="home-button-login" id="enviar-support" type="submit"
                                                        :disabled="$v.formEstudiante.$invalid">
                                                    <span>SIGUIENTE</span>
                                                </button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-tab>
                                <b-tab title-link-class="tab-link" title-item-class="tabs-home" title="RESULTADOS">
                                    <b-card-text class="welcome2 text-center">
                                        Bienvenido, por favor ingresa el Key proporcionado por el
                                        Coordinador de tu Colegio.
                                    </b-card-text>
                                    <b-form  @submit.stop.prevent="onSubmit" class="content-form-2 mt-5">
                                        <b-form-group label-align="center" id="formColegioEmail">
                                            <b-form-input
                                                    class="input-login-estudiante"
                                                    v-model="$v.formEstudianterRegistrado.codigo.$model"
                                                    placeholder="Key"
                                                    aria-describedby="keysLiveFeedback"
                                                    :state="estudianteRegistradoKeysState('codigo')"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="keysLiveFeedback">
                                                Debe ingresar un key
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-form-group label-align="center" id="formColegioEmail" class="mt-4">
                                            <b-form-input
                                                    class="input-login-estudiante"
                                                    v-model="$v.formEstudianterRegistrado.dni.$model"
                                                    placeholder="DNI"
                                                    aria-describedby="keysLiveFeedback"
                                                    :state="estudianteRegistradoDniState('dni')"
                                            ></b-form-input>
                                            <b-form-invalid-feedback id="keysLiveFeedback">
                                                Debe ingresar un Dni valido
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                        <b-row class="mt-lg-5">
                                            <b-col style="text-align: center">
                                                <button class="home-button-login" id="enviar-support2" type="submit"
                                                        :disabled="$v.formEstudianterRegistrado.$invalid">
                                                    <span>INGRESAR</span>
                                                </button>
                                            </b-col>
                                        </b-row>
                                    </b-form>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-row>
                </b-form>
            </b-col>
            <b-col class="home-col2" md="7" sm="6" lg="8" cols="0">
                <img class="home-image" src="@/assets/images/home.jpg" alt/>
            </b-col>
        </b-row>
        <b-modal
                content-class="modal-finish"
                hide-footer
                ref="modal-validacion"
                hide-header-close
                centered
                size="md"
        >
            <b-row align-h="center" style="text-align:center" class="examen-finish">
                <img class="error-img" src="@/assets/images/error.svg" alt/>
            </b-row>
            <b-row align-h="center" style="text-align:center; color:#0F376E" class="mt-4 mb-3">
                <p>{{titulo}}</p>
            </b-row>
            <b-row align-h="center" class="mb-2">
                <button @click="accept()" class="home-button-login">ACEPTAR</button>
            </b-row>
        </b-modal>
        <b-modal
                content-class="modal-finish"
                hide-footer
                ref="modal-simulacro"
                hide-header-close
                centered
                size="md"
        >
            <b-row align-h="center" style="text-align:center" class="examen-finish">
                <img class="error-img" src="@/assets/images/error.svg" alt/>
            </b-row>
            <b-row align-h="center" style="text-align:center; color:#0F376E" class="mt-4 mb-3">
                <p>{{titulo}}</p>
            </b-row>
            <b-row align-h="center" class="mb-2">
                <button @click="redirect()" class="home-button-login">ACEPTAR</button>
            </b-row>
        </b-modal>
    </b-container>
</template>

<script>
    import {mapState} from "vuex";
    import {validationMixin} from "vuelidate";
    import {required, email, numeric, minLength, maxLength} from "vuelidate/lib/validators";
    import moment from 'moment';

    export default {
        name: "Home",
        mixins: [validationMixin],
        components: {},
        data: () => ({
            titulo: "",
            select: "login",
            keys: "",
            typePassword: 'password',
            changePassword: true,
            formEstudiante: {
                keys: "",
                correo:""
            },
            formColegio: {
                email: "",
                password: ""
            },
            formAsesor: {
                email: "",
                password: ""
            },
            form: {
                dni: "",
                correo: "",
                codigo: ""
            },
            formEstudianterRegistrado: {
                codigo: "",
                dni: ""
            }
        }),
        validations: {
            formColegio: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            },
            formAsesor: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            },
            form: {
                email: {
                    required,
                    email
                },
                password: {
                    required
                }
            },
            formEstudiante: {
                keys: {
                    required
                },
                correo: {
                    email,
                    required,
                },
            },
            formEstudianterRegistrado: {
                codigo: {
                    required
                },
                dni: {
                    required,
                    numeric,
                    minLength: minLength(8),
                    maxLength: maxLength(9)
                }
            }
        },
        created() {
            localStorage.clear()
            if (this.start === 'student') {
                this.select = this.start;
            }
        },
        methods: {
            checkEmail(emailAddress) {
                var re = /\S+@\S+\.\S+/;
                this.emailValid = re.test(emailAddress);
            },
            accept() {
                this.$refs["modal-validacion"].hide();
            },
            enviarKey() {
                this.select = "student";
                this.data = this.formEstudiante
                this.$store
                    .dispatch("verifykey", this.data)
                    .then(response => {
                        if (response.data.keys.is_landing==0 && response.data.keys.key && !response.data.maximo && !response.data.caducado) {
                            this.$router.push("register");
                            localStorage.setItem('menu', 1)
                            localStorage.setItem('estudianteKey', null);
                            this.$store.dispatch("setKey", response.data.keys);
                            localStorage.setItem('mailEstudiante', this.formEstudiante.correo);
                        }
                        if(response.data.keys.is_landing==1 && response.data.estudiante && response.data.keys.key && !response.data.maximo && !response.data.caducado){
                            this.$router.push("register");
                            localStorage.setItem('menu', 1)
                            this.$store.dispatch("setKeyEstudiante", response.data.estudiante);
                            localStorage.setItem('estudianteKey', JSON.stringify(response.data.estudiante));
                            this.$store.dispatch("setKey", response.data.keys);
                        }
                        if (response.data.keys.is_landing==1 && !response.data.estudiante) {
                            this.titulo =
                            "El correo no se encuentra en nuestra base de datos, por favor registrate en el siguiente link: https://examen-simulacro.com";
                            this.$refs["modal-validacion"].show();
                        }
                        if (response.data.maximo) {
                            this.titulo =
                                "Este key a alcanzado el Numero maximo de participantes";
                            this.$refs["modal-validacion"].show();
                        }
                        if (response.data.caducado && response.data.keys.is_landing==1) {
                            this.titulo = "Este Key se habilitará el "+ moment(String(response.data.keys.desde)).format('DD/MM/YYYY')+" Hasta "+ moment(String(response.data.keys.hasta)).format('DD/MM/YYYY');
                            this.$refs["modal-validacion"].show();
                        }
                        if (response.data.caducado && response.data.keys.is_landing==0) {
                            this.titulo =
                            "Este key a caducado";
                            this.$refs["modal-validacion"].show();
                        }
                    })
                    .catch(error => {
                        this.titulo = "Key no Valido";
                        this.$refs["modal-validacion"].show();

                        console.log(error.message);
                    });
            },
            loginColegio(evt) {
                evt.preventDefault()
                this.$store.dispatch("loginColegio", this.formColegio).then(response => {
                    if (response.data) {
                        this.$store.commit("setJwtToken", response.data.token);
                        console.log('aqui loginColegio', response.data.user)
                        this.$store.commit("setUserData", response.data.user);
                        this.$router.push("/colegio");
                    }
                });
            },
            redirect() {
                console.log("easdasdasdasd");
                this.$router.push("/simulacros");
            },
            loginAsesor() {
                this.$store.dispatch("loginAsesor", this.formAsesor).then(response => {
                    if (response.data) {
                        this.$store.commit("setJwtToken", response.data.token);
                        this.$store.commit("setUserData", response.data.user);
                        this.$router.push("/asesor");
                    }
                })
                    .catch(error => {
                        this.titulo = "Usuario o clave invalida";
                        this.$refs["modal-validacion"].show();
                        console.log("", error.message);
                    });
            },
            onSubmit() {
                //this.formEstudianterRegistrado.codigo = this.formEstudianterRegistrado.codigo
                //this.formEstudianterRegistrado.dni = this.formEstudianterRegistrado.dni
                this.$store
                    .dispatch("loginEstudiante", this.formEstudianterRegistrado)
                    .then(response => {
                        console.log(response.data);
                        console.log(response.data.user);
                        if (response.data.user.id && response.data.horas != "no") {
                            this.$store.commit("setJwtToken", response.data.token);
                            this.$store.commit("setUserData", response.data.user);
                            localStorage.setItem("idkey", response.data.user.key_simulacro);
                            localStorage.setItem("isLanding", response.data.keys.is_landing);
                            localStorage.setItem('menu', 2)
                            this.$router.push("/result");
                        }
                        /*if (response.data.horas === false) {
                            this.titulo =
                                "Por favor espere 24 horas depues de haber realizado el simulacro";
                            this.$refs["modal-validacion"].show();
                        }*/
                        if (response.data.horas == "no") {
                            this.$store.commit("setJwtToken", response.data.token);
                            this.$store.commit("setUserData", response.data.user);
                            this.titulo = "Usted no ha realizado ningun simulacro";
                            this.$refs["modal-simulacro"].show();
                        }
                    })
                    .catch(error => {
                        this.titulo = "Usuario o Key invalida";
                        this.$refs["modal-validacion"].show();
                        console.log("", error.message);
                    });
            },
            colegioEmailState() {
                const {$dirty, $error} = this.$v.formColegio.email;
                return $dirty ? !$error : null;
            },
            colegioPasswordState() {
                const {$dirty, $error} = this.$v.formColegio.password;
                return $dirty ? !$error : null;
            },
            showPassword() {
                this.changePassword = !this.changePassword

            },
            asesorEmailState() {
                const {$dirty, $error} = this.$v.formAsesor.email;
                return $dirty ? !$error : null;
            },
            asesorPasswordState() {
                const {$dirty, $error} = this.$v.formAsesor.password;
                return $dirty ? !$error : null;
            },
            estudianteKeysState() {
                const {$dirty, $error} = this.$v.formEstudiante.keys;
                return $dirty ? !$error : null;
            },
            estudianteRegistradoKeysState() {
                const {$dirty, $error} = this.$v.formEstudianterRegistrado.codigo;
                return $dirty ? !$error : null;
            },
            estudianteRegistradoDniState() {
                const {$dirty, $error} = this.$v.formEstudianterRegistrado.dni;
                return $dirty ? !$error : null;
            },
            validateState() {
                const {$dirty, $error} = this.$v.formEstudiante.correo;
                return $dirty ? !$error : null;
            },
        },
        computed: {
            ...mapState(["key", "user"]),
            start() {
                return this.$store.state.start
            }
        },
        watch: {
            changePassword(value) {
                if (value) {
                    this.typePassword = 'password'
                } else {
                    this.typePassword = 'text'
                }
            }
        }
    };
</script>
